export const ShipmentsKpisActionTypes = {
    API_RESPONSE_SUCCESS: '@@shipments-kpis/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@shipments-kpis/API_RESPONSE_ERROR',
    GET_SHIPMENTS_NO_SHIPMENTS_REQUEST: '@@shipments-kpis/GET_SHIPMENTS_NO_SHIPMENTS_REQUEST',
    GET_SHIPMENTS_NO_CUSTOMERS_REQUEST: '@@shipments-kpis/GET_SHIPMENTS_NO_CUSTOMERS_REQUEST',
    GET_SHIPMENTS_TOTAL_COST_REQUEST: '@@shipments-kpis/GET_SHIPMENTS_TOTAL_COST_REQUEST',
    GET_SHIPMENTS_BASE_COST_REQUEST: '@@shipments-kpis/GET_SHIPMENTS_BASE_COST_REQUEST',
    GET_SHIPMENTS_AVG_COST_REQUEST: '@@shipments-kpis/GET_SHIPMENTS_AVG_COST_REQUEST',
    GET_SHIPMENTS_AVG_SHIPPED_WEIGHT_REQUEST: '@@shipments-kpis/GET_SHIPMENTS_AVG_SHIPPED_WEIGHT_REQUEST',
    GET_SHIPMENTS_AVG_BILLED_WEIGHT_REQUEST: '@@shipments-kpis/GET_SHIPMENTS_AVG_BILLED_WEIGHT_REQUEST',
    GET_SHIPMENTS_NO_SHIPMENTS_BY_TIMEFRAME_REQUEST: '@@shipments-kpis/GET_SHIPMENTS_NO_SHIPMENTS_BY_TIMEFRAME_REQUEST',
    GET_SHIPMENTS_SOURCES_REQUEST: '@@shipments-kpis/GET_SHIPMENTS_SOURCES_REQUEST',
    GET_SHIPMENTS_PRODUCTS_REQUEST: '@@shipments-kpis/GET_SHIPMENTS_PRODUCTS_REQUEST',
    GET_SHIPMENTS_CARRIERS_REQUEST: '@@shipments-kpis/GET_SHIPMENTS_CARRIERS_REQUEST',
    GET_SHIPMENTS_DESTINATIONS_REQUEST: '@@shipments-kpis/GET_SHIPMENTS_DESTINATIONS_REQUEST',
    GET_SHIPMENTS_SHIPPED_WEIGHTS_REQUEST: '@@shipments-kpis/GET_SHIPMENTS_SHIPPED_WEIGHTS_REQUEST',
    GET_SHIPMENTS_BILLED_WEIGHTS_REQUEST: '@@shipments-kpis/GET_SHIPMENTS_BILLED_WEIGHTS_REQUEST',
    GET_SHIPMENTS_CARRIER_WEIGHTS_REQUEST: '@@shipments-kpis/GET_SHIPMENTS_CARRIER_WEIGHTS_REQUEST',
    GET_SHIPMENTS_TOTAL_COST_BY_TIMEFRAME_REQUEST: '@@shipments-kpis/GET_SHIPMENTS_TOTAL_COST_BY_TIMEFRAME_REQUEST',
    GET_SHIPMENTS_COUNT_BY_ZIP_CODE: '@@shipments-kpis/GET_SHIPMENTS_COUNT_BY_ZIP_CODE',
    GET_SHIP_FROM_LOCATIONS: '@@shipments-kpis/GET_SHIP_FROM_LOCATIONS',
    GET_AGGREGATED_COST_BY_SERVICE: '@@shipments-kpis/GET_AGGREGATED_COST_BY_SERVICE',
};
